"use strict";

import { RelayEnvironmentProvider, useRelayEnvironment as useRelayEnvironmentImported } from 'react-relay/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export { createEnvironment, getEnvironment, initPersistedEnvironment } from './base-environment';
export { createEnvironmentWithSubscription } from './subscription-environment';
export { GraphError } from './GraphError';
export { createGraphError } from './utils';
export const EnvironmentProvider = ({
  children,
  environment
}) => /*#__PURE__*/_jsx(RelayEnvironmentProvider, {
  environment: environment,
  children: children
});
export const useRelayEnvironment = () => useRelayEnvironmentImported();